import { observable } from 'mobx';
import Client from '../../common/client';

const AuthStore = observable({
  loading: false,
  user: null,
  error: null,

  *login(id, password, saveId, companyCode) {
    this.loading = true;
    this.error = null;

    try {
      let response = yield Client.post('/Cems/Login/Login/', {
        companyCode: '1000000098',
        id: id,
        password: password,
      });

      //console.log('AuthStore > *login response : ', response);

      const user = response.data[0];
      
      //console.log('AuthStore > *login user : ', user);
      
      if (user) {
        if (user.ResultYN) {
          sessionStorage.setItem('user', JSON.stringify(user));
          this.user = user;
        } else {
          this.error = user.ResultMessage;
        }
      } else {
        this.error = '사용자를 확인할 수 없습니다.';
      }
    } catch (error) {
      //console.log(`AuthStore > *login : ${error.message}`);

      this.error = `AuthStore > *login : ${error.message}`;
    }

    this.loading = false;
  },

  logout() {
    sessionStorage.removeItem('user');
    this.user = null;
  },

  *updatePassword(passwordInfo, cusEntInfo) {
    // console.log(passwordInfo.newPassword);
    // console.log(passwordInfo.newPasswordConfirm);
    // console.log(cusEntInfo.Id)
    // console.log(cusEntInfo.EntCode)

    if (!this.user) {
      return { error: true, message: '사용자를 확인할 수 없습니다.' };
    }
    else if (passwordInfo.newPassword.length < 4 ) {
      return {
        error: true,
        message: '4자 이상의 새 비밀번호를 입력해 주시기 바랍니다.',
      };
    }

    else if (passwordInfo.newPasswordConfirm.length < 4 ) {
      return {
        error: true,
        message: '4자 이상의 새 비밀번호 확인을 입력해 주시기 바랍니다.',
      };
    }

    else if (passwordInfo.newPassword !== passwordInfo.newPasswordConfirm) {
      return {
        error: true,
        message: '새 비밀번호와 새 비밀번호 확인이 일치하지 않습니다.',
      };
    }

    try {
      let response = yield Client.post('/Cems/Login/UpdatePassword/', {
        companyCode: '1000000098',
        entCode: cusEntInfo.EntCode,
        id: cusEntInfo.Id,
        password: passwordInfo.newPassword,
      });

      const result = response.data[0];

      //console.log('AuthStore > *updatePassword result : ', result);

      if (result.ResultYN) {
        return {
          error: true,
        };
      } else {
        return {
          error: false,
          message: result.ResultMessage,
        };
      }
    } catch (error) {
      return {
        error: true,
        message: error.message,
      };
    }
  },

  *loginAdmin(id, password, saveId, companyCode) {
    this.error = null;

    try {
      let response = yield Client.post('/Cems/Login/LoginAdmin/', {
        companyCode: '1000000098',
        id: id,
        password: password,
      });

      const user = response.data[0];
      
      if (user) {

        if (user.ResultYN) {
          return {
            error: true,
          };
        } else {
          return {
            error: false,
            message: user.ResultMessage,
          };
        }
      } else {
        return {
          error: false,
          message: '사용자를 확인할 수 없습니다.'
        };
      }
    } catch (error) {
      //console.log(`AuthStore > *login : ${error.message}`);
      return {
        error: false,
        message: `AuthStore > *login : ${error.message}`
      };
    }
  },

  setUser(user) {
    this.user = user;
  },
});

export default AuthStore;
